import { render, staticRenderFns } from "./DataIteratorFooter.vue?vue&type=template&id=90d259e0&scoped=true"
import script from "./DataIteratorFooter.vue?vue&type=script&lang=js"
export * from "./DataIteratorFooter.vue?vue&type=script&lang=js"
import style0 from "./DataIteratorFooter.vue?vue&type=style&index=0&id=90d259e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d259e0",
  null
  
)

export default component.exports